<template>
  <esg-base-dashboard-card title="제품 LCA (Life Cycle Assessment) 산정 비율">
    <b class="annotation">클릭 시 상세 진척상황을 확인하실 수 있습니다</b>
    <esg-table-without-meta :items="items"
                            :fields="fields"
                            :selectable=true
                            @rowClicked=onRowClicked
                            size="sm"
                            class="my-2"
                            max-height="250px">
      <template #colgroup>
        <col style="width: 20%">
        <col style="width: 20%">
        <col style="width: 20%">
        <col style="width: 40%">
      </template>
      <template #cell(assignee)="data">
        <td>
          <div class="assignee-wrap">
                <span class="user-profile">
                  <img src="../../../../assets/images/icon_user.png"
                       alt="user profile">
                </span>
            <span class="assignee-name">{{ data.value }}</span>
          </div>
        </td>
      </template>
      <template #cell(progress)="data">
        <td>
          <div class="d-flex justify-content-between align-items-center">
            <div class="progress lca-progress"
                 style=""
                 :data-status="data.item.status === 'on_schedule' ? '진행 중' : '지연'">
              <div class="progress-bar"
                   :style="progressBarStyle(data.item)"></div>
            </div>
            <span class="lca-progress-value">{{ formatNumber(data.value, 0) }}%</span>
          </div>
        </td>
      </template>
    </esg-table-without-meta>

    <esg-base-dashboard-modal id="esg-lca-progress">
      <b-form>
        <!-- 핵심 과제 -->
        <b-form-group label-for="keyTask"
                      label="핵심과제">
          <b-input id="keyTask"
                   type="text"
                   v-model="selectedItem.keyTask"/>
        </b-form-group>
        <!-- /핵심 과제 -->

        <!-- 지표 -->
        <b-form-group label-for="indicator"
                      label="지표">
          <div class="d-flex justify-content-between align-items-center">
            <div class="progress lca-progress"
                 style="height: 1.5rem"
                 :data-status="selectedItem.status === 'on_schedule' ? '진행 중' : '지연'">
              <div class="progress-bar"
                   :style="progressBarStyle(selectedItem)"></div>
            </div>
            <span class="lca-progress-value">{{ formatNumber(selectedItem.progress, 0) }}%</span>
          </div>
          <div class="mt-2">
            진행: {{ selectedItem.inProgress }}, 완료: {{ selectedItem.done }}, 목표: {{ selectedItem.goal }}
          </div>
        </b-form-group>
        <!-- /지표 -->

        <!-- 상태 -->
        <b-form-group label-for="status"
                      label="상태">
          <b-select id="status"
                    v-model="selectedItem.status">
            <b-select-option value="on_schedule">On Schedule</b-select-option>
            <b-select-option value="delayed">Delayed</b-select-option>
          </b-select>
        </b-form-group>
        <!-- /상태 -->

        <!-- 특이사항 -->
        <b-form-group label="특이사항"
                      label-for="remark">
          <b-input id="remark"
                   type="text"
                   v-model="selectedItem.remark"/>
        </b-form-group>
        <!-- /특이사항 -->
      </b-form>
    </esg-base-dashboard-modal>

  </esg-base-dashboard-card>
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseDashboardModal from "@/components/esg/base/EsgBaseDashboardModal.vue";
import EsgBaseTable from "@/components/esg/base/EsgBaseTable.vue";
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  components: { EsgTableWithoutMeta, EsgBaseTable, EsgBaseDashboardModal, EsgBaseDashboardCard },
  computed: {
    colors() {
      return this.$store.getters['ghg/colors'];
    }
  },
  props: [],
  data() {
    return {
      selectedItem: {
        "productFamily": '',
        "department": "",
        "assignee": "",
        "progress": 0,

        "keyTask": '',
        "inProgress": 0,
        "done": 0,
        "goal": 0,
        "status": '',
        "remark": "",
      },
      items: [
        {
          "productFamily": "합성고무 제품군",
          "department": "ESG",
          "assignee": "문경태",
          "progress": 50,

          "keyTask": '니트릴 부타디엔 고무 LCA 데이터 구축',
          "inProgress": 4,
          "done": 10,
          "goal": 15,
          "status": 'on_schedule',
          "remark": "원료 데이터 미수집 18/35",
        },
        {
          "productFamily": "합성수지 제품군",
          "department": "ESG",
          "assignee": "이승경",
          "progress": 65,

          "keyTask": '합성수지 제품군 20% LCA 데이터 구축',
          "inProgress": 2,
          "done": 20,
          "goal": 15,
          "status": 'on_schedule',
          "remark": "원료 데이터 미수집 18/35",
        },
        {
          "productFamily": "고형고무 제품군",
          "department": "ESG",
          "assignee": "김민수",
          "progress": 50,

          "keyTask": '고형고무 제품군 40% LCA 데이터 구축',
          "inProgress": 3,
          "done": 7,
          "goal": 15,
          "status": 'on_schedule',
          "remark": "원료 데이터 미수집 20/35",
        },
        {
          "productFamily": "LATEX 제품군",
          "department": "ESG",
          "assignee": "윤지원",
          "progress": 10,

          "keyTask": 'LATEX 제품군 20% LCA 데이터 구축',
          "inProgress": 5,
          "done": 10,
          "goal": 15,
          "status": 'delayed',
          "remark": "ERP 인터페이스",
        }
      ],
      fields: [
        {
          name: 'productFamily',
          label: '제품군',
          list: true,
          sortable: true,
        },
        {
          name: 'department',
          label: '담당부서',
          list: true,
          sortable: true,
        },
        {
          name: 'assignee',
          label: '담당자',
          list: true,
          sortable: true,
        },
        {
          name: 'progress',
          label: '진척률',
          list: true,
          type: Number,
          formatter: val => this.formatNumber(val, 0),
          sortable: true,
        },
      ]
    }
  },
  methods: {
    onRowClicked(item, index) {
      this.selectedItem = item;
      this.$bvModal.show('esg-lca-progress');
    },
    progressBarStyle(item) {
      return {
        width: `${item.progress}%`,
        'background-color': item.status === 'on_schedule' ? this.colors[1] : this.colors[3]
      }
    }
  }
}
</script>

<style scoped>
>>> {
  font-family: 'NanumGothic';
}

>>> table.table td {
  cursor: pointer;
}

>>> table.table td,
>>> table.table th {
  font-family: 'NanumGothic';
  font-size: .9rem;
  text-align: center;
  vertical-align: middle;
}

>>> .lca-progress {
  display: inline-flex;
  width: 60%;
  margin-right: 1rem;
}

>>> .lca-progress-value {
  width: 30%;
  text-align: start;
}

>>> .assignee-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 0;
  width: 100%;
  white-space: nowrap;
}

>>> .assignee-wrap .user-profile {
  position: relative;
  flex-shrink: 0;
  display: inline-block;
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
}

>>> .assignee-wrap .assignee-name {
  width: 3rem;
}

>>> .progress.lca-progress {
  background-color: #e7eaed;
  position: relative;
  height: 1.5rem;
  width: 75% !important;
  min-width: 80px;
}

>>> .progress.lca-progress::after {
  content: attr(data-status);
  position: absolute;
  top: .8rem;
  left: 10px;
  font-family: NanumGothic;
  font-weight: 700;
  font-size: .875rem;
  vertical-align: middle;
}

.lca-progress-value {
  font-weight: 600;
  width: 25% !important;
}

.annotation {
  font-size: 10px;
  font-weight: 500;
  font-family: NanumGothic;
  color: #888;
  display: block;
  text-align: end;
}
</style>